import { generateApiRoute } from '@klp/core/api/helpers';

import type { MessageStatus } from './classes';

export const messageApiName = 'oppslagstavle';
const forsideFeedApiName = 'forsidefeed';
const fileApiName = 'file';
export const notificationApiName = 'notification';
export const sendSampleApiName = 'sendSample';

export const messageApiRoutes = {
    list: () => generateApiRoute([messageApiName]),
    boardSummary: () => generateApiRoute([messageApiName, forsideFeedApiName]),
    single: (messageId: number) =>
        generateApiRoute([messageApiName, messageId]),
    status: (messageId: number, status: MessageStatus) =>
        generateApiRoute([messageApiName, messageId, 'state', status]),
    buildingAndCustomer: () =>
        generateApiRoute([messageApiName, 'buildingandcustomer']),
    messageFile: (messageId?: number) =>
        generateApiRoute([messageApiName, messageId, fileApiName]),
    messagePreview: (messageId?: number) =>
        generateApiRoute([messageApiName, messageId, 'preview']),
};
